/**
 * 请求工具模块
 */

// 导入统一配置管理
import { getAppConfig, isDebugMode } from './config.js';

// 请求工具
const request = {
  // 基础配置
  config: {
    // 动态获取API基础地址
    get baseURL() {
      return getAppConfig().API_BASE_URL;
    },
    
    get timeout() {
      return getAppConfig().TIMEOUT;
    },
    
    get debug() {
      return getAppConfig().DEBUG;
    },
    
    header: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  },
  
  // 拦截器
  interceptors: {
    request: (config) => {
      // 每次请求前重新获取token
      let token = uni.getStorageSync('token');
      
      // 处理token可能存在的格式问题
      if (token) {
        // 去除可能的引号和空格
        if (typeof token === 'string') {
          token = token.trim();
          // 去除可能的引号
          if ((token.startsWith('"') && token.endsWith('"')) || 
              (token.startsWith("'") && token.endsWith("'"))) {
            token = token.substring(1, token.length - 1);
          }
        }
        // 确保token没有包含前缀
        if (token && token.startsWith('ba-user-token:')) {
          token = token.substring('ba-user-token:'.length);
        }
      }
      
      // 确保请求头对象存在
      if (!config.header) {
        config.header = {};
      }
      
      if (token) {
        // 同时设置多个认证头以确保兼容性
        config.header['ba-user-token'] = token;
        config.header['Authorization'] = 'Bearer ' + token;
        
        // 同时在全局保存当前使用的token
        if (getApp() && getApp().globalData) {
          getApp().globalData.token = token;
        }
      }
      
      // 使用server=1参数
      if (config.url && !config.url.includes('server=1')) {
        if (!config.url.includes('?')) {
          config.url += '?server=1';
        } else {
          config.url += '&server=1';
        }
      }
      
      // 调试模式下的请求信息
      if (isDebugMode()) {
        // 调试信息已禁用
      }
      
      return config;
    },
    
    response: (response) => {
      // 调试模式下的响应信息
      if (isDebugMode()) {
        // 调试信息已禁用
      }
      
      // 错误码处理
      if (response.statusCode === 403) {
        // 服务器返回403，可能是权限问题或token过期
        
        // 检查是否是token问题
        if (response.data && (response.data.type === 'need login' || 
            response.data.msg === '请先登录' || 
            response.data.msg === 'token无效或过期')) {
          
          // 获取当前页面信息
          const pages = getCurrentPages();
          const currentPage = pages[pages.length - 1];
          const currentRoute = currentPage ? currentPage.route : null;
          
          // 检查是否在登录页或其他不需要登录的页面
          const noLoginPages = ['pages/login/index', 'pages/login/register', 'pages/agreement/user', 'pages/agreement/privacy'];
          if (currentRoute && !noLoginPages.includes(currentRoute)) {
            // 检测到token无效，需要重新登录
            
            // 清除本地token
            uni.removeStorageSync('token');
            
            // 清除全局状态
            if (getApp() && getApp().globalData) {
              getApp().globalData.token = '';
              getApp().globalData.isLogin = false;
            }
            
            // 提示用户并跳转
            uni.showToast({
              title: 'token已过期，请重新登录',
              icon: 'none',
              duration: 2000
            });
            
            setTimeout(() => {
              uni.reLaunch({
                url: '/pages/login/index'
              });
            }, 1000);
          }
          
          return { type: 'need login', msg: '请重新登录' };
        }
      }
      
      // 处理登录相关的响应
      if (response.data && response.data.type === 'need login') {
        // 服务器返回需要登录状态
        
        // 获取当前页面信息
        const pages = getCurrentPages();
        const currentPage = pages[pages.length - 1];
        const currentRoute = currentPage ? currentPage.route : null;
        
        // 检查是否在登录页或其他不需要登录的页面
        const noLoginPages = ['pages/login/index', 'pages/login/register', 'pages/agreement/user', 'pages/agreement/privacy'];
        if (currentRoute && !noLoginPages.includes(currentRoute)) {
        // 清除本地token
        uni.removeStorageSync('token');
          
          // 清除全局状态
          if (getApp() && getApp().globalData) {
            getApp().globalData.token = '';
            getApp().globalData.isLogin = false;
          }
          
          uni.showToast({
            title: '登录已失效，请重新登录',
            icon: 'none',
            duration: 2000
          });
          
          setTimeout(() => {
            uni.reLaunch({
              url: '/pages/login/index'
            });
          }, 1000);
        }
        
        return { type: 'need login', msg: '请重新登录' };
      }
      
      return response.data;
    }
  },

  // 请求方法封装
  request(options = {}, retryCount = 0) {
    try {
      // 合并配置
      options.url = this.config.baseURL + options.url;
      options.header = Object.assign({}, this.config.header, options.header);
      options.timeout = options.timeout || this.config.timeout;
    
    // 请求拦截
      options = this.interceptors.request(options);
    
    // 发起请求
    return new Promise((resolve, reject) => {
        // 特殊处理短信验证码请求
        if (options.url.includes('api/Stsms/send') || options.url.includes('api/stsms/send')) {
          // 发送短信验证码请求
        }
        
      uni.request({
          ...options,
          success: async (res) => {
          try {
              const data = await this.interceptors.response(res);
              
              // 处理队列等待的情况
              if (res.statusCode === 200 && data.msg === '请排队中') {
                if (retryCount < this.maxRetries) {
                  // 请求在队列中，稍后重试
                  await new Promise(resolve => setTimeout(resolve, this.retryDelay))
                  return this.request(options, retryCount + 1)
                } else {
                  throw new Error('请求超时，请稍后重试')
                }
              }
              
              // 处理正常响应
              if (res.statusCode >= 200 && res.statusCode < 300) {
                resolve(data);
              } else {
                throw new Error(`HTTP Error: ${res.statusCode}`);
              }
          } catch (error) {
              // 特殊处理短信验证码错误
              if (options.url.includes('api/Stsms/send') || options.url.includes('api/stsms/send')) {
                // 短信验证码请求失败
              }
            reject(error);
            }
          },
          fail: async (err) => {
            // 网络请求错误
            
            // 特殊处理网络错误
            let errorMsg = err.errMsg || '网络请求失败';
            
            // 网络连接失败处理
            if (err.errMsg && err.errMsg.includes('Failed to connect')) {
              errorMsg = '无法连接到服务器，请检查网络';
            }
            
            // 网络请求失败重试机制
            if (retryCount < this.maxRetries) {
              // 请求失败，稍后重试
              await new Promise(resolve => setTimeout(resolve, this.retryDelay))
              return this.request(options, retryCount + 1)
            }
            
            reject(new Error(errorMsg));
          }
          });
      });
    } catch (error) {
      // Request failed
      reject(error);
    }
  },
  
  // GET请求
  get(url, params = {}, options = {}) {
    // 构建查询字符串
    let queryString = '';
    if (Object.keys(params).length > 0) {
      queryString = '&' + Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    }
    
    // 添加到URL
    const requestUrl = url + (url.includes('?') ? queryString : queryString.replace('&', '?'));
    
    return this.request({
      url: requestUrl,
      method: 'GET',
      ...options
    });
  },
  
  // POST请求
  post(url, data = {}, options = {}) {
    return this.request({
      url,
      data,
      method: 'POST',
      ...options
    });
  },
  
  // PUT请求
  put(url, data = {}, options = {}) {
    return this.request({
      url,
      data,
      method: 'PUT',
      ...options
    });
  },
  
  // DELETE请求
  delete(url, data = {}, options = {}) {
    return this.request({
      url,
      data,
      method: 'DELETE',
      ...options
    });
  },
  
  // 上传文件
  upload(url, filePath, formData = {}, options = {}) {
    // 请求拦截
    let token = uni.getStorageSync('token');
    
    // 处理token可能存在的格式问题
    if (token) {
      // 去除可能的引号和空格
      if (typeof token === 'string') {
        token = token.trim();
        // 去除可能的引号
        if ((token.startsWith('"') && token.endsWith('"')) || 
            (token.startsWith("'") && token.endsWith("'"))) {
          token = token.substring(1, token.length - 1);
        }
      }
      // 确保token没有包含前缀
      if (token && token.startsWith('ba-user-token:')) {
        token = token.substring('ba-user-token:'.length);
      }
    }
    
    const header = {
      ...options.header
    };
    
    if (token) {
      // 同时设置两种认证头，确保兼容性
      header['ba-user-token'] = token;
      header['Authorization'] = `Bearer ${token}`;
    }
    
    // 添加server=1参数
    const uploadUrl = url.includes('?') ? 
      `${url}&server=1` : 
      `${url}?server=1`;
    
    // 显示加载提示
    if (options.loading !== false) {
      uni.showLoading({
        title: options.loadingText || '上传中...',
        mask: true
      });
    }
    
    return new Promise((resolve, reject) => {
      uni.uploadFile({
        url: uploadUrl.startsWith('http') ? uploadUrl : this.config.baseURL + uploadUrl,
        filePath,
        name: options.name || 'file',
        formData,
        header,
        success: (response) => {
          try {
            // 上传接口返回的是字符串，需要转换为对象
            if (typeof response.data === 'string') {
              response.data = JSON.parse(response.data);
            }
            
            const result = this.interceptors.response(response);
            resolve(result);
          } catch (error) {
            reject(error);
            
            if (options.showError !== false) {
              uni.showToast({
                title: error.message || '上传失败',
                icon: 'none',
                duration: 2000
              });
            }
          }
        },
        fail: (error) => {
          reject(error);
          
          if (options.showError !== false) {
            uni.showToast({
              title: '上传失败',
              icon: 'none',
              duration: 2000
            });
          }
        },
        complete: () => {
          if (options.loading !== false) {
            uni.hideLoading();
          }
        }
      });
    });
  }
}; 

export default request; 